import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
// @ts-ignore
import styled from 'styled-components/macro';

const FieldWrapper = styled.div`
  margin: 0.5rem 0;
`;

const ErrorMessage = styled.span`
  color: red;
`;

function TextField({ name, placeholder }: any) {
  return (
    <Field name={name} type='text'>
      {({ input, meta }) => (
        <FieldWrapper>
          <input
            {...input}
            placeholder={placeholder}
          />
          {meta.error && meta.touched && <ErrorMessage>{meta.error}</ErrorMessage>}
        </FieldWrapper>
      )}
    </Field>
  );
}

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default TextField;
